// The pure gear queries (§31 A0), split out of `campaign/equipment.ts` so the
// industry (the power network feeding a Shield Generator, §31 A9) can ask
// them without importing the campaign's reducer half. Re-exported there.

import { type Gear, type IndustryState, type StructureKind, structureAt } from "./state";

export const gearOf = (industry: IndustryState): readonly Gear[] => industry.gear ?? [];

/** Does this gear give its bearer the function now? */
export function gearPowered(industry: IndustryState, gear: Gear): boolean {
  if (gear.side < 0) return false;
  const anchor = structureAt(industry, gear.anchor);
  return (
    anchor !== undefined &&
    anchor.kind === gear.kind &&
    (anchor.owner === gear.side || anchor.owner === gear.origin)
  );
}

/** How many of this artifact's functions this side has — `hasPower` and the Relic count. */
export function poweredCount(industry: IndustryState, side: number, kind: StructureKind): number {
  let n = 0;
  for (const gear of gearOf(industry)) {
    if (gear.kind === kind && gear.side === side && gearPowered(industry, gear)) n++;
  }
  return n;
}

/** The powered gear anchored to the structure on `anchor`, or undefined. */
export const poweredGearAt = (industry: IndustryState, anchor: number): Gear | undefined =>
  gearOf(industry).find((gear) => gear.anchor === anchor && gearPowered(industry, gear));
